let select;
let menu;
let status = false;
let options;
let active;
let showValueElement;
let input;
let icon;


export default () => {
    select = document.getElementById('select');

    if (!select) {
        return;
    }

    menu = document.getElementById('select-menu');
    options = menu.querySelectorAll('[data-code]');
    active = options[0].getAttribute('data-code');
    showValueElement = document.getElementById('show-value');
    input = document.getElementById('interest');
    icon = document.getElementById('select-icon');

    setActive(options[0]);

    select.addEventListener('click', () => {
        if (status) {
            closeMenu(menu);
        } else {
            openMenu(menu);
        }
    });

    options.forEach((option) => {
        option.addEventListener('click', (e) => {
            const element = getOptionElement(e.target);

            if (active !== element.getAttribute('data-code')) {
                deactivate();

                setActive(element);
            }
        });
    })
};

function getOptionElement(element) {
    if (!element.hasAttribute('data-code')) {
        return getOptionElement(element.parentNode);
    }

    return element;
}

function openMenu(menu) {
    menu.classList.remove('hidden');
    menu.classList.remove('opacity-0');
    menu.classList.add('opacity-100');
    icon.classList.add('rotate-180');

    status = true;
}

function closeMenu(menu) {
    menu.classList.add('opacity-0');
    menu.classList.remove('opacity-100');
    icon.classList.remove('rotate-180');

    window.setTimeout(() => {
        menu.classList.add('hidden');

        status = false;
    }, 100);
}

function setActive(option) {
    option.querySelector('.checkmark').classList.remove('hidden');

    const primary = showValueElement.querySelector('[data-primary]');
    const value = showValueElement.querySelector('[data-value]');

    primary.innerText = option.querySelector('[data-primary]').innerText;
    value.innerText = option.querySelector('[data-value]').innerText;

    active = option.getAttribute('data-code');
    input.value = active;

    closeMenu(menu);
}

function deactivate() {
    const option = document.querySelector('[data-code="' + active + '"]');

    option.querySelector('.checkmark').classList.add('hidden');
}
